import { FaCircle } from "react-icons/fa";
import Table from "../../../components/table/table";

const RegisteredList = ({ t }) => {
  const employees = [
    {
      name: "هشام المدير هشام",
      type: "عائلي",
      attendance: "حاضر",
    },
    {
      name: "هشام المدير هشام",
      type: "عائلي",
      attendance: "حاضر",
    },
    {
      name: "علاء صفوت",
      type: "شبابي",
      attendance: "حاضر",
    },
    {
      name: "هشام المدير هشام",
      type: "عائلي",
      attendance: "حاضر",
    },
    {
      name: "علاء صفوت",
      type: "شبابي",
      attendance: "حاضر",
    },
  ];

  const tableHead = [
    {
      header: t("name"),
      accessorKey: "name",
    },
    {
      header: t("membershipType"),
      accessorKey: "type",
    },
    {
      header: t("attendance1"),
      accessorKey: "attendance",
    },
  ];
  const tableData = employees.map((m, i) => {
    const attendance = (
      <span className="flex items-center justify-center gap-1">
        <FaCircle size={14} className="text-[#11A849]" />
        {m.attendance}
      </span>
    );

    return {
      name: m.name,
      type: m.type,
      attendance,
    };
  });
  return (
    <section>
      <h3 className="my-4 font-semibold text-primary">{t("registrationList")}</h3>

      <Table TableData={tableData} TableHead={tableHead} />
    </section>
  );
};

export default RegisteredList;
